export default __webpack_public_path__ + "static/media/bx-linkedin.15221df3.svg";